import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class ForceDownloadLoadPathFilesCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }

  async run(load_path_id:string, storage_value:string): Promise<any> {
    let params = '{"load_path_id": ' + load_path_id + '}'
    let args = { 
      storage_value: storage_value,
      params: params,
      manual: true
    }
    await this.dispatcher.dispatch('storage.webhook', args)
  }
}